<app-dialog-header [title]="deliveryType.id ? 'general.api_fees_delivery_type_edit' : 'general.api_fees_delivery_type_create'"
                   [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<div class="dialog-info" *ngIf="deliveryType?.id">
  <div class="flex flex-wrap">
    <div class="label-value">
      <span class="label">{{ 'general.api_delivery_types_table_classifier_name' | translate }}:</span>
      {{ deliveryType.classifierName }}
    </div>
  </div>
</div>
<mat-dialog-content class="flex flex-column">
  <app-text-input [label]="'general.api_delivery_types_table_classifier_name'" [(value)]="deliveryType.classifierName" [max]="DELIVERY_TYPE_CLASSIFIER_MAX_LENGTH"
                  [required]="true"></app-text-input>

  <div class="flex flex-grow flex-wrap flex-column">
    <div class="heading-5 no-margin">
      {{ 'general.api_delivery_types_table_sales_channels' | translate }}
      <span class="text-warning">*</span>
    </div>
    <div class="flex flex-column">
      <div>
        <mat-slide-toggle [(ngModel)]="isWebShopEnabled">
          <span>{{ 'general.api_delivery_types_table_sales_channel_webshop' | translate }}</span>
        </mat-slide-toggle>
        <mat-icon class="toggle-tooltip svg-icon text-muted left-spacer-half" [svgIcon]="'alert'"
                  [matTooltip]="'general.api_delivery_types_sales_channel_webshop_tooltip' | translate"></mat-icon>
      </div>
      <div>
        <mat-slide-toggle [(ngModel)]="isBoEnabled">
          <span>{{ 'general.api_delivery_types_table_sales_channel_bo' | translate }}</span>
        </mat-slide-toggle>
        <mat-icon class="toggle-tooltip svg-icon text-muted left-spacer-half" [svgIcon]="'alert'"
                  [matTooltip]="'general.api_delivery_types_sales_channel_bo_tooltip' | translate"></mat-icon>
      </div>
    </div>
    <div class="heading-5 no-margin">
      {{ 'general.api_delivery_types_table_attachments' | translate }}
      <mat-icon *ngIf="authService.user.projectManager" class="svg-icon text-muted valign-middle" [svgIcon]="'info'"
                [matTooltip]="'general.api_delivery_types_table_attachments_tooltip' | translate"></mat-icon>
    </div>
    <div class="card-grid grid-2 grid-column-mobile">
      <mat-slide-toggle *ngFor="let attachment of ATTACHMENTS" (change)="updateAttachment($event, attachment)"
                        [checked]="deliveryType.attachments.includes(attachment)" [required]="isAttachementRequired(attachment)">
        <span>{{ ('general.api_delivery_types_attachment_' + (attachment | lowercase)) | translate }}</span>
        <span class="text-warning" *ngIf="isAttachementRequired(attachment)">&nbsp;*</span>
      </mat-slide-toggle>
    </div>
  </div>

  <div class="heading-5 no-margin">
    {{ 'general.api_delivery_types_dialog_email_translation_keys' | translate }}
    <mat-icon class="svg-icon text-muted valign-middle" [svgIcon]="'info'"
              [matTooltip]="'general.api_delivery_types_dialog_email_translation_tooltip' | translate"></mat-icon>
  </div>
  <div class="flex flex-grow flex-wrap">
    <app-text-input [label]="'general.api_delivery_types_table_email_subject_key'" [(value)]="deliveryType.emailSubjectKey" [required]="true"></app-text-input>
    <app-text-input [label]="'general.api_delivery_types_table_email_body_key'" [(value)]="deliveryType.emailBodyKey" [required]="true"></app-text-input>
  </div>

  <hr class="slim">
  <ng-container *ngIf="deliveryType.id">
    <div class="heading-5 no-margin">{{ 'general.api_fees_current_fee' | translate }}</div>
    <app-info-message *ngIf="!deliveryType.sortedFee.currentPeriodPrice" [icon]="'alert'" [message]="'general.api_fees_no_current_fee'"></app-info-message>
    <ng-container *ngIf="deliveryType.sortedFee.currentPeriodPrice">
      <div class="bordered-listing-wrapper bottom-spacer" *ngIf="utilService.isMobile">
        <ng-container [ngTemplateOutlet]="periodPriceRowMobileTemplate" [ngTemplateOutletContext]="{periodPrice: deliveryType.sortedFee.currentPeriodPrice}"></ng-container>
      </div>
      <table class="report-table" *ngIf="!utilService.isMobile">
        <thead>
          <tr>
            <th class="min-width break-word">{{ 'general.api_fees_table_fee_amount' | translate }}</th>
            <th class="min-width">{{ 'general.api_fees_table_fee_vat' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_start' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_end' | translate }}</th>
            <th class="min-width">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-container [ngTemplateOutlet]="periodPriceRowTemplate" [ngTemplateOutletContext]="{periodPrice: deliveryType.sortedFee.currentPeriodPrice}"></ng-container>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
  <mat-tab-group mat-align-tabs="left" class="tabs no-body max-width" [(selectedIndex)]="activeTab">
    <mat-tab [label]="'general.api_fees_tab_upcoming' | translate"></mat-tab>
    <mat-tab *ngIf="deliveryType.id" [label]="'general.api_fees_tab_past' | translate"></mat-tab>
  </mat-tab-group>
  <div *ngIf="activeTab === 0">
    <ng-container *ngIf="!deliveryType.sortedFee.futurePeriodPrices?.length && !periodPricesForPostList.length">
      <app-info-message [icon]="'alert'" [message]="'general.api_fees_no_records'"></app-info-message>
      <br>
    </ng-container>
    <ng-container *ngIf="periodPricesForPostList.length || deliveryType.sortedFee.futurePeriodPrices?.length || isPeriodCreate">
      <div class="bordered-listing-wrapper bottom-spacer" *ngIf="utilService.isMobile">
        <ng-container *ngFor="let periodPrice of deliveryType.sortedFee.futurePeriodPrices" [ngTemplateOutlet]="periodPriceRowMobileTemplate"
                      [ngTemplateOutletContext]="{periodPrice: periodPrice}"></ng-container>
        <ng-container *ngFor="let periodPriceKey of periodPricesForPostList" [ngTemplateOutlet]="periodPriceRowMobileTemplate"
                      [ngTemplateOutletContext]="{periodPrice: periodPricesForPost[periodPriceKey], uniqueId: periodPriceKey}"></ng-container>
        <ng-container *ngIf="isPeriodCreate" [ngTemplateOutlet]="activePeriodPriceMobileTemplate"></ng-container>
      </div>
      <table class="report-table bottom-spacer" *ngIf="!utilService.isMobile">
        <thead>
          <tr>
            <th class="break-word flex-shrink">{{ 'general.api_fees_table_fee_amount' | translate }}</th>
            <th class="break-word flex-shrink">{{ 'general.api_fees_table_fee_vat' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_start' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_end' | translate }}</th>
            <th class="min-width">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let periodPrice of deliveryType.sortedFee.futurePeriodPrices" [ngTemplateOutlet]="periodPriceRowTemplate"
                        [ngTemplateOutletContext]="{periodPrice: periodPrice}"></ng-container>
          <ng-container *ngFor="let periodPriceKey of periodPricesForPostList" [ngTemplateOutlet]="periodPriceRowTemplate"
                        [ngTemplateOutletContext]="{periodPrice: periodPricesForPost[periodPriceKey], uniqueId: periodPriceKey}"></ng-container>
          <tr *ngIf="isPeriodCreate">
            <ng-container [ngTemplateOutlet]="activePeriodPriceTemplate"></ng-container>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <app-link *ngIf="!isPeriodCreate" [link]="'general.api_fees_period_add'" [icon]="'plus'"
              (linkClicked)="addPeriodPrice()" [disabled]="!!activePeriodPrice"></app-link>
  </div>
  <div *ngIf="activeTab === 1">
    <ng-container *ngIf="!deliveryType.sortedFee.pastPeriodPrices?.length">
      <app-info-message [icon]="'alert'" [message]="'general.api_fees_no_records'"></app-info-message>
      <br>
    </ng-container>
    <ng-container *ngIf="deliveryType.sortedFee.pastPeriodPrices?.length">
      <div class="bordered-listing-wrapper bottom-spacer" *ngIf="utilService.isMobile">
        <ng-container *ngFor="let periodPrice of deliveryType.sortedFee.pastPeriodPrices" [ngTemplateOutlet]="periodPriceRowMobileTemplate"
                      [ngTemplateOutletContext]="{periodPrice: periodPrice, isPast: true}"></ng-container>
      </div>
      <table class="report-table" *ngIf="!utilService.isMobile">
        <thead>
          <tr>
            <th class="break-word flex-shrink">{{ 'general.api_fees_table_fee_amount' | translate }}</th>
            <th class="break-word flex-shrink">{{ 'general.api_fees_table_fee_vat' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_start' | translate }}</th>
            <th class="break-word">{{ 'general.api_fees_table_fee_end' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let periodPrice of deliveryType.sortedFee.pastPeriodPrices" [ngTemplateOutlet]="periodPriceRowTemplate"
                        [ngTemplateOutletContext]="{periodPrice: periodPrice, isPast: true}"></ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
  <hr class="slim">
  <app-lang-tabs [fields]="translationFields" [baseItem]="deliveryType" [(selectedLanguages)]="selectedLanguages"
                 (valueChanges)="validateTranslations()"></app-lang-tabs>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="feeDialogButtons"></app-dialog-footer>
<ng-template #feeDialogButtons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button mat-button (click)="confirmClose()">{{ 'general.api_general_cancel' | translate }}</button>
      <button mat-flat-button color="primary" (click)="saveDeliveryType()" [disabled]="!!activePeriodPrice || !isValid">
        {{ (deliveryType.id ? 'general.api_fees_save' : 'general.api_fees_create') | translate }}
      </button>
    </div>
  </div>
</ng-template>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
<ng-template #periodPriceRowMobileTemplate let-periodPrice="periodPrice" let-isPast="isPast" let-uniqueId="uniqueId">
  <div class="listing-block" *ngIf="!isActivePeriodPrice(periodPrice.id, uniqueId)">
    <div class="header-block flex flex-center space-between bottom-spacer">
      <div>
        <div class="heading-5 no-margin text-base break-word bold">
          <span class="medium">{{ 'general.api_fees_table_fee_amount' | translate }}</span>
          {{ periodPrice.feeAmount | price }}
        </div>
      </div>
      <div class="white-space-no-wrap no-grow no-min-width" *ngIf="!isPast">
        <div class="flex flex-end decreased-margin">
          <button mat-button class="input-button icon-button" (click)="editPeriodPrice(periodPrice, uniqueId)" [disabled]="!!activePeriodPrice">
            <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button" *ngIf="!isCurrentPeriodPrice(periodPrice.id, periodPrice.period.start)"
                  (click)="removePeriodPrice(periodPrice.id, uniqueId)" [disabled]="!!activePeriodPrice">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <table class="mobile-max-width mobile-columns">
      <tbody>
        <tr>
          <td class="medium">{{ 'general.api_fees_table_fee_vat' | translate }}</td>
          <td class="align-right">{{ periodPrice.vatPercentage }}%</td>
        </tr>
        <tr>
          <td class="medium">{{ 'general.api_fees_table_fee_start' | translate }}</td>
          <td class="align-right">{{ periodPrice.period.start | moment: { withTime: true } }}</td>
        </tr>
        <tr>
          <td class="medium">{{ 'general.api_fees_table_fee_end' | translate }}</td>
          <td class="align-right">{{ periodPrice.period.end ? (periodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-container *ngIf="isActivePeriodPrice(periodPrice.id, uniqueId)" [ngTemplateOutlet]="activePeriodPriceMobileTemplate"></ng-container>
</ng-template>
<ng-template #periodPriceRowTemplate let-periodPrice="periodPrice" let-isPast="isPast" let-uniqueId="uniqueId">
  <tr>
    <ng-container *ngIf="!isActivePeriodPrice(periodPrice.id, uniqueId)">
      <td class="white-space-no-wrap">{{ periodPrice.feeAmount | price }}</td>
      <td class="white-space-no-wrap">{{ periodPrice.vatPercentage }}%</td>
      <td>{{ periodPrice.period.start | moment: { withTime: true } }}</td>
      <td>{{ periodPrice.period.end ? (periodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
      <td class="white-space-no-wrap flex decreased-margin" *ngIf="!isPast">
        <button mat-button class="input-button icon-button" (click)="editPeriodPrice(periodPrice, uniqueId)" [disabled]="!!activePeriodPrice">
          <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
        </button>
        <button mat-button class="input-button icon-button" *ngIf="!isCurrentPeriodPrice(periodPrice.id, periodPrice.period.start)"
                (click)="removePeriodPrice(periodPrice.id, uniqueId)" [disabled]="!!activePeriodPrice">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container *ngIf="isActivePeriodPrice(periodPrice.id, uniqueId)" [ngTemplateOutlet]="activePeriodPriceTemplate"></ng-container>
  </tr>
</ng-template>
<ng-template #activePeriodPriceMobileTemplate>
  <div class="listing-block">
    <div class="header-block flex flex-top space-between bottom-spacer">
      <div>
        <div class="heading-5 no-margin text-base break-word bold">
          <span class="medium">{{ 'general.api_fees_table_fee_amount' | translate }}</span>
          <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
            {{ (activePeriodPrice.feeAmount * 100) | price }}
          </ng-container>
          <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
            <br>
            <ng-container [ngTemplateOutlet]="activePriceInput"></ng-container>
          </ng-container>
        </div>
      </div>
      <div class="white-space-no-wrap no-grow no-min-width">
        <div class="flex flex-end decreased-margin">
          <button mat-button class="input-button filter-button icon-button" (click)="savePeriodPrice(activePeriodPrice.uniqueId)"
                  [disabled]="!canSavePeriodPrice">
            <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
          </button>
          <button mat-button class="input-button filter-button icon-button" (click)="clearActivePeriodPrice()">
            <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <table class="mobile-max-width mobile-columns">
      <tbody>
        <tr>
          <td class="medium" [ngClass]="{'valign-middle': !isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)}">
            {{ 'general.api_fees_table_fee_vat' | translate }}
          </td>
          <td class="align-right">
            <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
              {{ activePeriodPrice.vatPercentage }}%
            </ng-container>
            <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)"
                          [ngTemplateOutlet]="activePercentageInput"></ng-container>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="medium">{{ 'general.api_fees_table_fee_start' | translate }}</td>
        </tr>
        <tr>
          <td colspan="2" class="max-width">
            <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
              {{ activePeriodPrice.period.start | moment: { withTime: true } }}
            </ng-container>
            <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)"
                          [ngTemplateOutlet]="activeStartDateInput"></ng-container>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="medium">{{ 'general.api_fees_table_fee_end' | translate }}</td>
        </tr>
        <tr>
          <td colspan="2" class="max-width" [ngClass]="{'valign-middle': !showEndDatepicker}">
            <ng-container [ngTemplateOutlet]="activeEndDateInput"></ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-template #activePeriodPriceTemplate>
  <td class="min-width white-space-no-wrap">
    <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
      {{ (activePeriodPrice.feeAmount * 100) | price }}
    </ng-container>
    <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)"
                  [ngTemplateOutlet]="activePriceInput"></ng-container>
  </td>
  <td class="min-width white-space-no-wrap">
    <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
      {{ activePeriodPrice.vatPercentage }}%
    </ng-container>
    <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)"
                  [ngTemplateOutlet]="activePercentageInput"></ng-container>
  </td>
  <td class="limited-width">
    <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)">
      {{ activePeriodPrice.period.start | moment: { withTime: true } }}
    </ng-container>
    <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.period?.start)"
                  [ngTemplateOutlet]="activeStartDateInput"></ng-container>
  </td>
  <td class="limited-width" [ngClass]="{'valign-middle': !showEndDatepicker}">
    <ng-container [ngTemplateOutlet]="activeEndDateInput"></ng-container>
  </td>
  <td class="white-space-no-wrap align-right">
    <button mat-button class="input-button filter-button icon-button right-spacer-half" (click)="savePeriodPrice(activePeriodPrice.uniqueId)"
            [disabled]="!canSavePeriodPrice">
      <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
    </button>
    <button mat-button class="input-button filter-button icon-button" (click)="clearActivePeriodPrice()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </td>
</ng-template>
<ng-template #activePriceInput>
  <app-numeric-input [appClass]="'compact'" [(value)]="activePeriodPrice.feeAmount" [required]="true"
                     [type]="NumericInputType.Price">
  </app-numeric-input>
</ng-template>
<ng-template #activePercentageInput>
  <app-numeric-input [appClass]="'compact'" [(value)]="activePeriodPrice.vatPercentage"
                     [allowPercentageDecimalPlaces]="true"
                     [type]="NumericInputType.Percentage" [placeholder]="legalVatPercentage != null ? legalVatPercentage.toString() : '-'">
  </app-numeric-input>
</ng-template>
<ng-template #activeStartDateInput>
  <app-datepicker [datePickerConfig]="datePickerConfig" [timezone]="authService.user.timezone" [(date)]="activePeriodPrice.period.start"
                  [required]="true" [valid]="isPeriodStartValid" (dateTimeChanged)="validatePeriodStart()"></app-datepicker>
</ng-template>
<ng-template #activeEndDateInput>
  <app-link class="table-icon-link" *ngIf="!showEndDatepicker" [link]="'general.api_fees_add_period_end'" [icon]="'plus'"
            (linkClicked)="setDefaultEndDate()" [disabled]="!activePeriodPrice.period?.start"></app-link>
  <app-datepicker *ngIf="showEndDatepicker" [datePickerConfig]="datePickerConfig" [timezone]="authService.user.timezone" [(date)]="activePeriodPrice.period.end"
                  [minDate]="minEndDate || activePeriodPrice.period.start" [disabled]="!activePeriodPrice.period?.start"
                  [valid]="isPeriodEndValid" (dateTimeChanged)="validatePeriodEnd()"></app-datepicker>
</ng-template>
